import { Controller } from '@hotwired/stimulus';
import DataTable from 'datatables.net-dt';

window.$.fn.DataTable = window.dt = DataTable;

export default class TradeListController extends Controller {
    static values = {
        type: { type: String, default: 'date' },
        enabled: { type: Boolean, default: true },
    };

    initialize () {
        // console.log('TradeListController.initialize', this.element.dataset, this.element);
        // new DataTable(); // no-op because DT seems to balk at first instance when used via Stim
        // this.configDataTable();
    }

    connect () {
        // console.log('TradeListController.connect', this.element);
        if (this.enabledValue) {
            this.configDataTable();
        }

    }

    disconnect() {
        // console.log('TradeListController.disconnect', this.element);
        // this.dataTable.clear();
    }

    configDataTable () {
        if (this.dataTable) {
            console.log("already configured")
            // console.log('TradeListController.configDataTable(false)', this.element.id, this.element.dataset, this);
            return;
        }

        // console.log('TradeListController.configDataTable(true)', this.element.id, this.element.dataset, this);

        const menu = (this.element.dataset.longTable === 'true') ? [[20, 50, -1], [20, 50, 'All']] : [[5, 20, -1], [5, 20, 'All']];

        let ordering = "false" !== this.element.dataset.ordering;
        let pageLength = parseInt(this.element.dataset.pageLength);
        if (!pageLength) {
            pageLength = menu[0][0];
        }
        let pagingType = this.element.dataset.pagingType;
        if (!pagingType) {
            pagingType = 'simple_numbers';
        }
        let showSearch = this.element.dataset.search === 'true'
        let showChangeLength = this.element.dataset.changeLength === 'true'

        const dtConfig = {
            layout: {
                topStart: showChangeLength ? 'pageLength' : null,
                topEnd: showSearch ? 'search' : null,
                bottomStart: 'info',
                bottomEnd: 'paging',
                // bottom: ['info', 'pageLength', 'paging']
            },
            destroy: false,
            pageLength,
            paging: this.element.dataset.paging !== 'false',
            pagingType,
            ordering,
            searching: showSearch,
            lengthMenu: menu,
            lengthChange: showChangeLength,
            language: {
                info: '_START_ to _END_ of _TOTAL_ entries',
                lengthMenu: 'Show _MENU_',
                search: '_INPUT_',
                searchPlaceholder: 'Search...'
            },
            responsive: false
        };

        // this.dataTable = window.$(this.element).DataTable(dtConfig);
        //     console.log('dtConfig', dtConfig);
            this.dataTable = new DataTable(this.element, dtConfig);
    }
}